import styled, { css } from 'styled-components';
import mediaQuery from 'styles/mediaQuery';
import theme from 'styles/theme';

export const DayCellDate = styled.span`
    width: 100%;
    height: 24px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 5px;
    font-size: 16px;
  }
`;

export const DayCellUnbookable = styled.span.attrs({
  className: 'day-cell-unbookable',
})<{ $isLoading?: boolean }>`
    font-size: 12px;
    color: ${theme.colors.gray600};
    display: flex;
    align-items: center;
    justify-content: center;
  
    ${({ $isLoading }) =>
      $isLoading &&
      `
        width: 30px;
        height: 8px;
        background-color: #ced4da;
      `}
  }
`;

export const DayCellMinStayAndUnbookableWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .day-cell-unbookable {
    margin-right: 4px;
  }
`;

export const DayCellMinStay = styled.span<{ $isLoading?: boolean }>`
    font-size: 12px;
    color: ${theme.colors.gray600};
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      margin-left: 4px;
    }
    ${({ $isLoading }) =>
      $isLoading &&
      `
        width: 30px;
        height: 8px;
        background-color: #ced4da;
      `}
  }
`;

export const DayCellPricing = styled.span<{ $isLoading?: boolean }>`
    color: ${theme.colors.gray600};
    font-size: 12px;

    ${({ $isLoading }) =>
      $isLoading &&
      `
         width: 20px;
        height: 8px;
        margin-top: 6px;
        background-color: #ced4da;
      `}
  }
`;

export const DayCellWrapper = styled.div<{
  $empty?: boolean;
  $borderRight?: boolean;
  $inRed?: boolean;
  $calendarStyleConstants: any;
}>`
    text-align:center;
    flex: 0 1  calc(100% / 7);
    ${({ $calendarStyleConstants }) =>
      $calendarStyleConstants &&
      `height: ${$calendarStyleConstants.days.height}px;`}
    background-color: transparent;
    ${({ $calendarStyleConstants }) =>
      $calendarStyleConstants &&
      `border-left: ${$calendarStyleConstants.border};`}
    ${({ $calendarStyleConstants }) =>
      $calendarStyleConstants &&
      `border-bottom: ${$calendarStyleConstants.border};`}
    position: relative;
    padding: 5px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    color: #212529;
    user-select: none;
    ${({ $empty }) => $empty && `border-left: none;`}
    ${({ $inRed }) =>
      $inRed &&
      css`
        color: ${theme.colors.hostfullyOrange};
      `}
    ${({ $borderRight, $calendarStyleConstants }) =>
      $borderRight && `border-right: ${$calendarStyleConstants.border};`}
  }

  &.highlight {
    background-color: #feffbc;
    border-color: #d4d664;
    transition: all 0.3s ease-in-out;
  }

  ${({ $inRed }) =>
    $inRed &&
    css`
      &:not(.date-before-today) {
        ${DayCellMinStay}, ${DayCellPricing} {
          color: ${theme.colors.hostfullyOrange};
        }
      }
    `}
`;

export const DayCellIconsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 5px;
  top: 8px;

  svg {
    color: ${theme.colors.hostfullyOrange};
  }

  ${mediaQuery.sm} {
    right: 3px;

    svg {
      --size: 14px;
      height: var(--size);
      width: var(--size);
    }
  }
`;

export const DayStringCellS = styled.div<{
  $hasBorder: boolean;
  $calendarStyleConstants: any;
}>`
    flex: 0 1  calc(100% / 7);
    height: 40px;
    text-align: center;
    padding: 0;
    padding-left: 5px;
    padding-right: 5px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 14px;
    font-weight: 400;
    border-bottom: none;

    ${({ $hasBorder, $calendarStyleConstants }) =>
      $hasBorder &&
      `
        border-bottom: ${$calendarStyleConstants.border};
      `}
  }
`;
